module.exports = __webpack_public_path__ + "b295b925f6db98bbddd3e2d0fe443eaa.jpg";